import anime from "animejs";
import Scene from "../classes/scene";
import SceneManager from "../classes/scene-manager";
import { ScrollDirection, ScrollHandler } from "../classes/scroll-manager";
import { ScrollAnimation } from "../components/scrolllocked-animations";
import { getEl, getEls, isGreaterThanOrEqualTo } from "../helpers";
import Globals from "../classes/globals";
import ResponsiveWatcher, { ResponsiveSize } from "../classes/responsive-watcher";

export default class People extends Scene {
  easeAnimation: ScrollAnimation;
  sidewaysScroller: ScrollAnimation;

  constructor(manager: SceneManager, targetContainer: string) {
    super(manager, targetContainer);


    const container = this.elContainer.querySelector(".ppl-spotlights");
    const sticky = this.elContainer.querySelector(".ppl-sticky");


    const spotlight0 = this.elContainer.querySelector(".ppl-spotlight-1");
    const spotlight1 = this.elContainer.querySelector(".ppl-spotlight-2");
    const spotlight2 = this.elContainer.querySelector(".ppl-spotlight-4");
    const spotlight3 = this.elContainer.querySelector(".ppl-spotlight-3");

    //SPOTLIGHT 0 ANIMATION
    if (spotlight0) {
      const spot0img = spotlight0.querySelector(".spot-image-background img");
      let s0dx = 0;
      let s0dy = 0;

      manager.app.spotlighter.addSpotlightAnimation(
        {
          targets: spotlight0.querySelector(".spot-image-background"),
          scale: [1, 1.2],
          duration: 2000,
          easing: "easeOutQuart",
        },
        spotlight0 as HTMLElement,
        200,
        (anim, delta) => {
          if (!spot0img) return;
          const xRatio = (anim.mouseX / anim.elWidth - 0.5) * -1;
          const yRatio = (anim.mouseY / anim.elHeight - 0.5) * -1;
          s0dx += (xRatio - s0dx) * delta * anim.smoothSpeed;
          s0dy += (yRatio - s0dy) * delta * anim.smoothSpeed;
          // @ts-ignore
          spot0img.style.transform = "translate(" + s0dx + "vw, " + s0dy + "vw)";
        },
        () => {
          const heading = spotlight0.querySelector(".spot-heading");
          if (heading) heading.dispatchEvent(new CustomEvent("play"));
        },
        true
      );

      spotlight0.addEventListener("click", (e) => {
        e.preventDefault();
        manager.app.modaller.openModal("diversity");
      });
    }

    //SPOTLIGHT 1 ANIMATION
    if (spotlight1) {
      manager.app.spotlighter.addSpotlightAnimation(
        {
          targets: spotlight1.querySelectorAll(".ppl-spotlight-large-impact"),
          scale: [0, 1],
          duration: 1500,
          easing: "easeOutCubic",
        },
        spotlight1 as HTMLElement,
        200,
        null,
        () => {
        }
      );

      spotlight1.addEventListener("click", (e) => {
        e.preventDefault();
        manager.app.modaller.openModal("social");
      });
    }

    //SPOTLIGHT 2 ANIMATION
    if (spotlight2) {
      manager.app.spotlighter.addSpotlightAnimation(
        {
          targets: spotlight2.querySelectorAll(".ppl-spotlight-wrapping-line-1, .ppl-spotlight-wrapping-line-2"),
          left: (el, i, len) =>
            [
              ["60%", "0%"],
              ["-100%", "-52.5%"],
            ][i],
          duration: 3000,
          easing: "easeOutQuart",
        },
        spotlight2 as HTMLElement,
        200,
        null,
        () => {
          spotlight2.querySelectorAll(".anim-heading").forEach((e) => e.dispatchEvent(new CustomEvent("play")));
        },
        true
      );

      spotlight2.addEventListener("click", (e) => {
        e.preventDefault();
        manager.app.modaller.openModal("stem");
      });
    }

    //SPOTLIGHT 3 ANIMATION
    if (spotlight3) {
      const spot3img = spotlight3.querySelector(".spot-image-background img");
      let dx = 0;
      let dy = 0;

      manager.app.spotlighter.addSpotlightAnimation(
        {
          targets: spotlight3.querySelector(".spot-image-background"),
          scale: [1, 1.1],
          duration: 2000,
          easing: "easeOutQuart",
        },
        spotlight3 as HTMLElement,
        200,
        (anim, delta) => {
          if (!spot3img) return;
          const xRatio = (anim.mouseX / anim.elWidth - 0.5) * -1;
          const yRatio = (anim.mouseY / anim.elHeight - 0.5) * -1;
          dx += (xRatio - dx) * delta * anim.smoothSpeed;
          dy += (yRatio - dy) * delta * anim.smoothSpeed;
          // @ts-ignore
          spot3img.style.transform = "translate(" + dx + "vw, " + dy + "vw)";
        },
        () => {
          const heading = spotlight3.querySelector(".spot-heading");
          if (heading) heading.dispatchEvent(new CustomEvent("play"));
        },
        true
      );

      spotlight3.addEventListener("click", (e) => {
        e.preventDefault();
        manager.app.modaller.openModal("humanrights");
      });
    }
  }

  onResponsiveChange(newSize: ResponsiveSize, oldSize: ResponsiveSize, responser: ResponsiveWatcher) {
    if (isGreaterThanOrEqualTo(newSize, ResponsiveSize.lg)) {
      if (this.sidewaysScroller) this.manager.app.scrolllocker.enableAnimation(this.sidewaysScroller);
      if (this.easeAnimation) this.manager.app.scrolllocker.enableAnimation(this.easeAnimation);
    } else {
      if (this.sidewaysScroller) this.manager.app.scrolllocker.disableAnimation(this.sidewaysScroller);
      if (this.easeAnimation) this.manager.app.scrolllocker.disableAnimation(this.easeAnimation);
    }
  }
	
}
